import React from 'react';
import Timeline from "./Timeline";
import CurrentActionOwnerInfo from "./CurrentActionOwnerInfo";

const TimelineContainer = ({ data }) => {
  const [ activeSegment, setActiveSegment ] = React.useState(null);

  const shownData = activeSegment ? data.find(segment => segment.id === activeSegment) : data[data.length-1];
  const lastDatasetShown = shownData == data[data.length-1];

  return (
    <div
      className="timeline-wrapper"
      style={{ borderColor: (lastDatasetShown && shownData) ? shownData.colour : 'transparent' }}
    >
      {
        shownData && (
          <CurrentActionOwnerInfo
            data={shownData}
            lastDatasetShown={lastDatasetShown}
          />
        )
      }
      <Timeline
        data={data}
        activeSegment={activeSegment}
        handleSegmentHover={setActiveSegment}
      />
    </div>

  );
}

export default TimelineContainer;
